module.exports = __webpack_public_path__ + "img/adv-mapIcon26.fdf04b41.png";